export class Chart {
  constructor({
        id= null, 
        name= ``, 
        xName= ``,
        xAttribute='',
        chartItems=[{yAttribute:'',yName:''}],
        description=``,
    } = {}) {
    this.id = id;
    this.name = name;
    this.xName = xName;
    this.xAttribute=xAttribute;
    this.chartItems=chartItems;
    this.description=description;
  }
}
export function newEntity() {
  return new Chart();
}
export function gridFields() {
  return Object.freeze([
      {
        key: 'name',
        label: 'lbl.chart.name',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'xAttribute',
        label: 'lbl.chart.xAttribute',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'xName',
        label: 'lbl.chart.xName',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'chartItems',
        label: 'lbl.chart.chartItems',
        sortable: true,
        form: {
          type: 'detailTable'
        }
      },
      {
        key: 'yAttribute',
        label: 'lbl.chart.yAttribute',
        notInTable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'yName',
        label: 'lbl.chart.yName',
        notInTable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'description',
        label: 'lbl.chart.description',
        sortable: true,
        form: {
          type: 'input'
        }
      },
  ]);
}
export const fields = Object.freeze(Object.keys(new Chart()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.nameFilter',
  'filter.descriptionFilter',
];
export const filter = {
  'nameFilter': "",
  'descriptionFilter': "",
};